<template>
	<div class="chartBox" style="width:100%;height:100%;">
		<div id="pieMain" ref="pie" style="width:100%; height:100%;}"></div>
	</div>
</template>

<script>
//vuex
import {mapState} from 'vuex'
let echarts = require('echarts/dist/echarts.simple.min');
var chart = null;
var pieData = [];
var runObj = {};
var stopObj = {};
export default {
  name: 'PieNFChart',
  props:['itemOn','itemOff','cntOn','cntOff','lcolor','rcolor'],
  computed:mapState({
  		currentIndex:state => state.home.currentIndex,
  		curSubTab:state=>state.home.curSubTab
  }),
   watch: {
  	cntOn: function (val) {
  	  this.initData();
      this.refresh();
   	},
   	cntOff: function (val) {
   	  this.initData();
      this.refresh();
    },
   	currentIndex(val){
  		if(val=='0'){
  			chart.resize()
  			this.setChart()
  		}else if(val.indexOf('file') != -1){
  			chart.resize()
  			this.setChart()
  		}else{
  			return
  		}
  	},
  	curSubTab(val){
		if(val=='detailHome'){
			chart.resize()
		 	this.setChart()
		}
	}
  },
  mounted(){
  	this.setChart()
  },
  methods:{
  	setChart(){
  		this.initData();
  		chart = echarts.init(this.$refs.pie);
	  	chart.setOption({
			tooltip: {},
			series: [{
				name: '',
				type: 'pie',
				radius: '100%',//饼图的半径，相对于容器高宽中较小的一项的百分比
				center: ['50%', '50%'],
				data: pieData,
				itemStyle: {
					emphasis: {
						shadowBlur: 10,
						shadowOffsetX: 0,
						shadowColor: 'rgba(0,0,0,0.5)'
					}
				}
			}]
		})
	  	$(window).resize(chart.resize);
  	},
  	initData(){
  		pieData=[];
  		if(this.cntOn!==0){
	  		runObj = {
		  		value:this.cntOn,
		  		name:this.itemOn,
		  		label:{
					normal:{
						position:'inside',
						formatter:'{b}:{d}%'
					}
				},
				itemStyle:{
					normal: {
						color:this.lcolor
					}
				}
		  	}
	  		pieData.push(runObj)
	  	}
	  	if(this.cntOff!=0){
	  		stopObj = {
		  		value:this.cntOff,
		  		name:this.itemOff,
		  		label:{
					normal:{
						position:'inside',
						formatter:'{b}:{d}%'
					}
				},
				itemStyle:{
					normal: {
						color:this.rcolor
					}
				}
		  	}
	  		pieData.push(stopObj)
	  	}
  	},
  	refresh(){
  		chart.setOption({
			tooltip: {},
			series: [{
				name: '',
				type: 'pie',
				radius: '100%',//饼图的半径，相对于容器高宽中较小的一项的百分比
				center: ['50%', '50%'],
				data: pieData,
				itemStyle: {
					emphasis: {
						shadowBlur: 10,
						shadowOffsetX: 0,
						shadowColor: 'rgba(0,0,0,0.5)'
					}
				}
			}]
		})
  	}
  }
}
</script>


// WEBPACK FOOTER //
// PieNFChart.vue?066037dc